const React = window.React;
const { createContext, useCallback, useEffect, useMemo, useRef, useState } = React;
import { get, set } from 'lodash';
let FormContext;
export function initializeFormContext() {
    if (typeof window === 'undefined')
        return;
    if (!window.__FormContextGlobal__) {
        window.__FormContextGlobal__ = createContext(null);
    }
    FormContext = window.__FormContextGlobal__;
    return FormContext;
}
export function getFormContext() {
    if (!FormContext) {
        console.warn('FormContext not initialized. Call initializeFormContext() first.');
        initializeFormContext();
    }
    return FormContext;
}
export const FormProvider = ({ initialValues = {}, onChange, children }) => {
    const FormContext = getFormContext();
    const initialValuesRef = useRef(initialValues);
    const [values, setValues] = useState(initialValues);
    useEffect(() => {
        if (initialValues !== initialValuesRef.current) {
            console.log('[FormProvider] 🔄 useEffect triggered - initialValues:', initialValues);
            initialValuesRef.current = initialValues;
            setValues(prev => ({ ...prev, ...initialValues }));
        }
    }, [initialValues]);
    const setFieldValue = useCallback((path, value) => {
        setValues(prev => {
            if (get(prev, path) === value)
                return prev;
            const newValues = { ...prev };
            set(newValues, path, value);
            console.log(`[FormProvider] 📝 Set field '${path}' to:`, value);
            if (onChange) {
                Promise.resolve().then(() => {
                    onChange(newValues);
                });
            }
            return newValues;
        });
    }, []);
    const contextValue = useMemo(() => ({
        values,
        setFieldValue,
        initialized: true
    }), [values, setFieldValue]);
    return (createElement(FormContext.Provider, { value: contextValue }, children));
};
